import { BrowserModuleNotInstalledError } from "../../core/errors.js";
import type { BrowserModule, ChromiumNamespace } from "./types.js";

interface MaybeModule {
  readonly chromium?: ChromiumNamespace;
}

async function tryImport(name: "patchright" | "playwright"): Promise<BrowserModule | null> {
  try {
    const mod = (await import(/* @vite-ignore */ name)) as MaybeModule;
    if (!mod.chromium) return null;
    return { name, chromium: mod.chromium };
  } catch {
    return null;
  }
}

export async function loadBrowserModule(): Promise<BrowserModule> {
  const p = await tryImport("patchright");
  if (p) return p;
  const w = await tryImport("playwright");
  if (w) return w;
  throw new BrowserModuleNotInstalledError();
}
